<template>
  <div id="app">
    <v-app id="app">
      <div v-cloak>
        <v-main class="cont">
          <v-container fluid class="cont">
            <!-- <v-overlay :value="state.overlay">
              <v-progress-circular
                indeterminate
                size="64"
              ></v-progress-circular>
            </v-overlay> -->
            <router-view></router-view>
            <div class="snackbar-wrapper">
              <v-snackbar v-model="state.snackbar" absolute>
                {{ state.snackbartext }}
                <template v-slot:action="{ attrs }">
                  <v-btn
                    v-bind="attrs"
                    color="pink"
                    text
                    @click="state.snackbar = false"
                  >
                    {{ $t("common.close") }}
                  </v-btn>
                </template>
              </v-snackbar>
            </div>

            <newformroute v-bind:payload="state.newformroute"></newformroute>
          </v-container>
        </v-main>
        <!--<v-snackbar v-model="state.snackbar">
          {{ state.snackbartext }}
          <template v-slot:action="{ attrs }">
            <v-btn
              color="pink"
              text
              v-bind="attrs"
              @click="state.snackbar = false"
              >{{ $t("common.close") }}</v-btn
            >
          </template>
        </v-snackbar>-->
      </div>
    </v-app>
    <!-- <v-dialog
      max-width="600px"
      min-width="360px"
      content-class="dialogcss"
      Modal
      persistent
      v-model="state.showlogindialog"
    >
      <v-card>
        <v-card-title class="headline">{{ $t("common.login") }}</v-card-title>
        <v-card-title class="cancel" @click.stop="state.showlogindialog = false"
          >x</v-card-title
        >
        <v-card-text>
          <div id="login-container-1"></div>
        </v-card-text>
      </v-card>
    </v-dialog> -->

    <div class="bkg-end1">
      <input id="clipcopyinput" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import router from "./router/router";
import i18n from "./i18n";
import { saveFile, getCountryCode } from "./services/firebase";
import { setLocale, ui, loadLocale } from "./services/firebase";
import newformroute from "./views/newformroute.vue";

export default {
  data() {
    return {
      env: process.env.NODE_ENV,
    };
  },
  onIdle() {
    this.logout();
  },
  components: {
    newformroute,
  },
  beforeCreate() {
    setLocale();
    var script = document.createElement("script");
    var language = "";
    switch (this.$store.state.locale) {
      case "en":
        language = "en";
        break;
      case "pt":
        language = "pt-BR";
        break;
      case "ru":
        language = "ru";
        break;
      case "es":
        language = "es-419";
        break;
      case "hi":
        language = "hi";
        break;
      case "gu":
        language = "gu";
        break;
    }
    script.src = `https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=${language}`;
    document.getElementsByTagName("head")[0].appendChild(script);
  },
  mounted() {
    this.$store.state.newformroute.newformdialog = false;
    this.$store.state.showlogindialog = false;

    if (this.$store.state.profile.uid) {
      if (window.location.href.split("?")[1]) {
        if (window.location.href.split("?")[1].split("=")[1])
          i18n.locale = window.location.href.split("?")[1].split("=")[1];
        else {
          setLocale();
          loadLocale(this.$store.state.profile.uid, function() {});
        }
      } else {
        setLocale();
        loadLocale(this.$store.state.profile.uid, function() {});
      }
    }
    getCountryCode();
    // this.$nextTick(() => {
    //   window.addEventListener("resize", this.onResize);
    // });

    if (this.env == "production") {
      console.log = function() {};
    }
    if (!this.$store.state.profile.isSigned) {
      ui();
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },

  methods: {
    logout: function() {
      this.$store.dispatch("logout");
    },
    startLogin: function() {
      this.$store.dispatch("startLogin");
    },
    createForm: function() {
      var storeData = this.$store;
      var createPos = this.getFreePos();
      if (createPos === -1) {
        alert(i18n.t("alertText.fiveForms"));
        return;
      }
      //this.selectType(createPos);
      this.selectType(function(type) {
        // console.log("Creating form, type:" + type);
        var newlink = "/admin/editform/" + createPos;
        // console.log(newlink);
        var newForm = {
          id: storeData.state.profile.uid,
          pos: createPos,
          categs: ["Ordering form", "Catalogue"],
          shopname: "",
          shopdesc: "",
          type: type,
          catalogue: [],
          phone: "+91",
          amount: 0,
          maxlength: 0,
        };

        saveFile(
          storeData.state.profile.uid,
          createPos,
          JSON.stringify(newForm),
          function() {
            //state.forms.push({"shopname": "", "type": + type, "link":"/admin/" + createPos});
            if (router.currentRoute.fullPath != newlink) {
              router.push("/admin/editform/" + createPos);
            }
          }
        );
      });
    },
    getFreePos() {
      var isPresent = [];
      for (var ii = 0; ii < 5; ii++) isPresent[ii] = false;
      for (var i = 0; i < this.$store.state.forms.length; i++) {
        var formlink = this.$store.state.forms[i].link;
        //var ipos = parseInt(formlink.split("/")[3]);
        var ipos;
        if (formlink.split("/")[3]) {
          ipos = parseInt(formlink.split("/")[3]);
        } else {
          ipos = parseInt(formlink.split("/")[2]);
        }

        if (ipos >= 0 && ipos < 5) isPresent[ipos] = true;
      }
      for (var j = 0; j < 5; j++) if (!isPresent[j]) return j;
      return -1;
    },
    selectType(callback) {
      this.$store.dispatch("setCurCallback", callback);
      //router.push("/newform");
      this.$store.state.newformroute.newformdialog = true;
      // console.log("1");
      this.$store.dispatch("setOverlay", false);
    },
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    // setIdleTimeLogout() {
    //   console.log("setIdleTimeLogout");

    //   let timerId = setInterval(() => {
    //     console.log("call setInterval", this.time);

    //     this.time -= 1000;
    //     console.log("this.time", this.time);

    //     if (!this.$store.state.idleVue.isIdle) {
    //       console.log(
    //         "if ==>!this.$store.state.idleVue.isIdle....",
    //         this.$store.state.idleVue.isIdle
    //       );

    //       clearInterval(timerId);
    //     }
    //     console.log("this.time out", this.time);

    //     if (this.time < 1) {
    //       clearInterval(timerId);
    //       // Your logout function should be over here
    //       alert("logout user....");
    //     }
    //   }, 1000);
    // },
  },
  /*
  watch: {
    windowWidth(newWidth, oldWidth) {},
  },*/

  computed: {
    ...mapGetters({
      user: "user",
      state: "state",
    }),
    showAppBar() {
      if (this.$route.name === "viewform" || this.$route.name === "base")
        return false;
      return true;
    },
    ordforms(state) {
      var toret = [];
      state = this.$store.state;
      if (state.forms) {
        for (var i = 0; i < state.forms.length; i++) {
          var f = state.forms[i];
          if (f.type === "Ordering form") {
            toret.push(f);
          }
        }
      }
      return toret;
    },
    catforms(state) {
      var toret = [];
      state = this.$store.state;
      if (state.forms) {
        for (var i = 0; i < state.forms.length; i++) {
          var f = state.forms[i];
          if (f.type === "Catalogue") {
            toret.push(f);
          }
        }
      }
      return toret;
    },
    isIdle() {
      console.log(
        "isIdle",
        this.$store.state,
        this.$store.state.idleVue.isIdle
      );
      return this.$store.state.idleVue.isIdle;
    },
  },
};
</script>
<style lang="scss">
.firebaseui-dialog {
  position: absolute;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.87);
  font: 16px Roboto, arial, sans-serif;
  height: auto;
  padding: 24px;
  text-align: left;
  top: 244.5px;
  left: 628px;
  right: 628px;
}
.firebaseui-list-box-dialog {
  display: block;
  visibility: visible;
}
.mdl-dialog,
.firebaseui-dialog,
.firebaseui-id-dialog {
  display: none;
  visibility: hidden;
}

.firebaseui-list-box-dialog {
  display: block;
  visibility: visible;
}
.v-list-item {
  min-height: 5px;
}
.v-divider {
  margin: 5px 0px;
}
div.v-list-item {
  min-height: 10px;
}
v-list-item {
  min-height: 10px;
}

// @media (min-width: 960px) {
//   .v-dialog__content{
//   width: 100%
// }}
@media (min-width: 320px) and (max-width: 960px) {
  .v-dialog__content .dialogcss,
  .v-dialog {
    margin: 5px;
  }
  .dialogcss {
    max-height: 60% !important;
  }
}
@media (max-height: 450px) {
  .g-recaptcha-bubble-arrow + div:not(.g-recaptcha-bubble-arrow) {
    overflow-y: scroll;
    height: 80vh !important;
  }
}
</style>
